/**
 * type for representing content-addressable filesystem hashes.
 */
export type Hash = string;
